
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { StepItemProps } from ".";
import { loading, index, options } from "store/step";

interface ApiStepInputProps {
    page?: number;
    pageSize?: number;
    q?: string;
}

type ApiStepOutputProps = OutputBaseProps<{ list: StepItemProps[]; pagination?: PaginationProps; }>

export const apiStepIndex = async (workflowId: number, data: ApiStepInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiStepOutputProps>(`/api/workflow/${workflowId}/steps`, { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};

export const apiStepOptions = async (workflowId: number, data: { q?: string; }) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiStepOutputProps>(`/api/workflow/${workflowId}/steps`, { params: { ...data, fields: "id,code,name,sort" } }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(options({ data: res.data.list }));
    }
    return res;
};

export const apiStepFormNextSteps = async (workflowId: number, currentStatusId: number, formId: number, multiple?: boolean) => {
    // store.dispatch(loading());
    const res = (await axios.get<ApiStepOutputProps>(`/api/workflow/${workflowId}/${formId}/step${multiple ? "/multiple" : ""}/${currentStatusId}/next-step`))
        .data;
    if (res.code === 0 && res.data) {
        // store.dispatch(options({ data: res.data.list }));
    }
    return res;
};